import React from 'react';
import './DobleGuion.scss';

export const DobleGuion = () => {

    return (
        <div className="doble-guion-container">
            <p className="doble-guion-content"></p>
            <p className="doble-guion-content"></p>
        </div>
    )
}
